import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable, of } from 'rxjs';
import { AttributeValues, ProductAttribute } from '../models/product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductAttributeService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readProductAttribute(subcategoryId: string): Observable<ProductAttribute[]> {
    return this.#http.getData(`${this.baseUrl}/subcategories/${subcategoryId}/attributes`, {
      showLoader: false,
      showMessage: false
    });
  }

  readProductAttributeById(id: string): Observable<ProductAttribute> {
    return this.#http.getData(`${this.baseUrl}/subcategories/attributes/${id}`, {
      showLoader: true,
      showMessage: false
    });
  }

  createProductAttribute(attribute: any) {
    return this.#http.postData(
      `${this.baseUrl}/subcategories/${attribute.subcategoryId}/attributes`,
      { showLoader: true, showMessage: true },
      attribute
    );
  }

  updateProductAttribute(productAttribute: any) {
    return this.#http.putData(`${this.baseUrl}/subcategories/attributes/${productAttribute.id}`, productAttribute, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteProductAttribute(id: string) {
    return this.#http.deleteData(`${this.baseUrl}/subcategories/attributes/${id}`, {
      showLoader: true,
      showMessage: true
    });
  }

  readProductAttributeValueById(attributeId: string, id: string): Observable<AttributeValues[]> {
    return this.#http.getData(`${this.baseUrl}/subcategories/attributes/${attributeId}/values/${id}`, {
      showLoader: true,
      showMessage: false
    });
  }

  createProductAttributeValue(id: string, value: string[]) {
    return this.#http.postData(
      `${this.baseUrl}/subcategories/attributes/${id}/values`,
      { showLoader: true, showMessage: true },
      { value }
    );
  }

  updateProductAttributeValue(id: string, attributeValue: any) {
    return this.#http.putData(`${this.baseUrl}/subcategories/attributes/attribute-values/${id}`, attributeValue.value, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteProductAttributeValue(id: string) {
    return this.#http.deleteData(`${this.baseUrl}/subcategories/attributes/attribute-values/${id}`, {
      showLoader: true,
      showMessage: true
    });
  }

  searchAttributeTypes(categoryId: string, searchTerm: string): Observable<string[]> {
    return this.#http.getData(
      `${this.baseUrl}/products/categories/${categoryId}/attribute-types/autofill?searchTerm=${encodeURIComponent(searchTerm)}`,
      { showLoader: false, showMessage: false }
    );
  }
}
